import produce from "immer";
import { ICultivationAdvicesReducer } from "models/.";
import { actionTypes } from "./actions";
import { adviceSorting as defaultSorting } from "constants/sorting";

const initialState: ICultivationAdvicesReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  currentItem: null,
  error: null,
  typeOptions: []
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_CULTIVATION_ADVICES_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = { ...state.meta, ...action.meta };
        break;
      case actionTypes.GET_CULTIVATION_ADVICES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_CULTIVATION_ADVICE_REQUEST:
        draftState.currentItem = null;
        break;
      case actionTypes.GET_CULTIVATION_ADVICE_SUCCESS:
        draftState.currentItem = action.payload;
        break;
      case actionTypes.GET_CULTIVATION_ADVICE_FAILURE:
        return {
          ...initialState,
          error: action.error
        };
      case actionTypes.REMOVE_CULTIVATION_ADVICES_SUCCESS:
        draftState.items = action.payload;
        break;
      case actionTypes.REMOVE_CULTIVATION_ADVICES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_CULTIVATION_SELECT_OPTIONS_REQUEST:
        draftState.typeOptions = [];
        break;
      case actionTypes.GET_CULTIVATION_SELECT_OPTIONS_SUCCESS:
        draftState.typeOptions = action.payload;
        break;
    }
  });
